import get from 'lodash/get';
import assign from 'lodash/assign';
import * as APIS from '../../constants/api';
import * as TYPES from '../../constants/actionTypes';

export const login =
  (credientials) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.USER_MANAGEMENT, credientials)
      .then((result) => {
        api.defaults.headers.common.authorization = `Bearer ${get(
          result,
          'token'
        )}`;
        dispatch({
          type: TYPES.LOGIN,
          payload: result,
        });
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const marketingOnBoarding =
  (credientials) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.USER_MANAGEMENT, credientials)
      .then((result) => {
        api.defaults.headers.common.authorization = `Bearer ${get(
          result,
          'token'
        )}`;
        dispatch({
          type: TYPES.LOGIN,
          payload: result,
        });
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const userMangement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.USER_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const refreshUserDetails =
  () =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.USER_MANAGEMENT, { action: 'me' })
      .then((result) => {
        dispatch({
          type: TYPES.REFRESH_USER,
          payload: result,
        });
      })
      .catch((error) => {
        throw error;
      });
